import React from 'react'

const Contact=(props)=>(
  <div className="contact">
    <div className="contact-title">
      <h1>Contacto</h1>
      <div className="title-graph-container"><img src="/media/graphs/phone.svg" alt="" className="title-graph"/></div>
    </div>
    <div className="form-container">
      <form action="https://docs.google.com/forms/u/0/d/e/1FAIpQLSfg32rPOHguzdFwtCY6MOo7tgr1TYLoLhB1ifCUH1ie7HbpDQ/formResponse" method='POST' id='mG61Hd' target='_blank'>
        <div className="inputs-container">
          <div className="shorts">
            <input type="text" jsname="YPqjbf" name="entry.1800284018" placeholder='Nombres' required className='input names-form'/>
            <input type="email" jsname="YPqjbf" name="entry.919364488" required placeholder='Email' className="input email-form"/>
            <input type="text" jsname="YPqjbf" placeholder='Empresa' name="entry.1012493573" className="input company-form"/>
          </div>
          <textarea jsname="YPqjbf" name="entry.901736561" className='input message-form' required cols="20" rows="5" placeholder='Mensaje'></textarea>
        </div>
        <input type="submit" value="Enviar" className="pointer form-submit button"/>
      </form>
    </div>
    {
      props.phrase
      ?(<p className='phrase'>{props.phrase}</p>)
      :(<></>)
    }
  </div>
)

export default Contact
